import React from "react";

interface OwnProps {
    badRequest?: boolean;
    forbidden?: boolean;
    movedPermanently?: boolean;
    notFound?: boolean;
    redirect?: boolean;
    serverError?: boolean;
    statusCode?: number;
    staticContext?: any;
    unauthorized?: boolean;
}

interface OwnState {
}

export class StatusCode extends React.Component<OwnProps, OwnState> {

    public componentWillMount() {
        if (this.props.staticContext) {
            this.props.staticContext.status = this.props.statusCode;

            if (this.props.movedPermanently)
                this.props.staticContext.status = 301;
            else if (this.props.redirect)
                this.props.staticContext.status = 302;
            else if (this.props.badRequest)
                this.props.staticContext.status = 400;
            else if (this.props.unauthorized)
                this.props.staticContext.status = 401;
            else if (this.props.forbidden)
                this.props.staticContext.status = 403;
            else if (this.props.notFound)
                this.props.staticContext.status = 404;
            else if (this.props.serverError)
                this.props.staticContext.status = 500;

            console.log("status code set to", this.props.staticContext);
        }
    }

    public render() {
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/components/generic/StatusCode.tsx